import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveServiceVideoSuccess,
  saveServiceVideoFailure,
  updateServiceVideoSuccess,
  updateServiceVideoFailure,
  deleteServiceVideoSuccess,
  deleteServiceVideoFailure,
  readServiceVideoSuccess,
  readServiceVideoFailure,
} from "./serviceVideosActions";

import {
  saveServiceVideo,
  updateServiceVideo,
  deleteServiceVideo,
  readServiceVideos,
} from "./serviceVideosAPI";

// SAVE
function* saveServiceVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveServiceVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveServiceVideoSuccess(res.data));
      toast.success(res.message || "Service Video Saved!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res?.error);
  } catch (err) {
    yield put(saveServiceVideoFailure(err.message));
    toast.error(err.message);
    action.callback?.({ type: 0, error: err.message });
  }
}

// UPDATE
function* updateServiceVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateServiceVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateServiceVideoSuccess(res.data));
      toast.success("Service Video Updated!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res?.error);
  } catch (err) {
    yield put(updateServiceVideoFailure(err.message));
    toast.error(err.message);
    action.callback?.({ type: 0, error: err.message });
  }
}

// DELETE
function* deleteServiceVideoSaga(action) {
  try {
    const res = yield call(deleteServiceVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteServiceVideoSuccess(action.payload));
      toast.success("Service Video Deleted!");
      action.callback?.({ type: 1, data: action.payload });
    } else throw new Error(res?.error);
  } catch (err) {
    yield put(deleteServiceVideoFailure(err.message));
    toast.error(err.message);
    action.callback?.({ type: 0, error: err.message });
  }
}

// READ
function* readServiceVideosSaga(action) {
  try {
    const res = yield call(readServiceVideos, action.payload);

    if (res?.type === 1) {
      yield put(readServiceVideoSuccess(res.data));
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res?.error);
  } catch (err) {
    yield put(readServiceVideoFailure(err.message));
    action.callback?.({ type: 0, error: err.message });
  }
}

// WATCHER
export default function* serviceVideoWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_SERVICE_VIDEO_REQUEST, saveServiceVideoSaga);
  yield takeLatest(actionTypes.UPDATE_SERVICE_VIDEO_REQUEST, updateServiceVideoSaga);
  yield takeLatest(actionTypes.DELETE_SERVICE_VIDEO_REQUEST, deleteServiceVideoSaga);
  yield takeLatest(actionTypes.READ_SERVICE_VIDEO_REQUEST, readServiceVideosSaga);
}
